export default {
  LayersControl: "Ebenen",
  SettingsControl: "Einstellungen",
  settings: {
    language: {
      title: "Sprache"
    },
    clustering: {
      title: "Clusterung",
      always: "Immer",
      never: "Niemals",
      dynamic: "Dynamisch"
    },
    functions: {
      title: "Funktionen",
      print: "Drucken",
      measure: "Messen"
    },
    layerLabel: "Karten-Ebenen",
    transparency: "Transparenz",
    dataPrivacy: "Impressum & Datenschutz",
    downloadMsg: "Jetzt City App herunterladen",
    legend: "Legende",
    backdrop: "Hintergrund",
    embedLinks: "Einbettungs-Links"
  },
  buttons: {
    fullscreen: "Vollbildmodus",
    popout: "Karte herauslösen",
    poisAndStreets: "Inhaltsverzeichnis",
    routing: "Routenplaner",
    close: "Schließen",
    gps: "Meine Position",
    streets: "Straßen",
    weather3D: "3D-Wetter"
  },
  menuPopup: {
    back: "Zurück zu den Ergebnissen",
    pois: "Kategorien",
    streets: "Straßen"
  },
  poiDetails: {
    moreInfo: "Mehr Infos",
    openingHours: "Öffnungszeiten",
    opened: "Geöffnet",
    closed: "Geschlossen",
    showMore: "Mehr zeigen",
    showLess: "Weniger zeigen",
    altitude: "Höhe",
    zmin: "Min. Höhe",
    zmax: "Max. Höhe",
    distance: "Entfernung",
    time: "Zeit",
    content: "Inhalt",
    ytitle: "Entfernung",
    xtitle: "Höhe"
  },
  measureComponent: {
    colorSelector: "Farbe",
    shape: "Form",
    measure: "Messen",
    length: "Länge",
    area: "Fläche",
    radius: "Radius",
    circumference: "Umfang",
    delete: "Alle löschen"
  },
  rightClickFrame: {
    startPoint: "Startpunkt wählen",
    endPoint: "Endpunkt wählen",
    whatIsHere: "Was befindet sich hier?",
    print: "Drucken",
    measure: "Messen"
  },
  routeFrame: {
    routeOptions: "Routenoptionen",
    highway: "Autobahnen",
    tollRoad: "Mautstraßen",
    ferry: "Fähren",
    units: "Einheiten",
    startPoint: "Startpunkt",
    midPoint: "Zwischenziel",
    endPoint: "Endpunkt",
    metric: "Metrisch (km)",
    imperial: "Angloamerikanisch (mi)",
    via: "über",
    departure: "Abfahrt:",
    details: "Details",
    error: "Ein Fehler ist aufgetreten:",
    getDirections: "Los!",
    switchPoints: "Wegpunkte tauschen",
    close: "Routenplaner schließen",
    directions_car: "Mit dem Auto",
    directions_bus: "Mit öffentlichen Verkehrsmitteln",
    directions_bike: "Mit dem Fahrrad",
    directions_walk: "Zu Fuß"
  },
  streetEntry: {num: "Nr."},
  searchPlaceholder: "Suche nach Sehenswürdigkeiten, Straßen oder Routen auf der Karte ...",
  searchFrame: {
    previous: "zurück",
    next: "weiter",
    loading: "Laden",
    error: "Ein Fehler ist aufgetreten",
    noResults: "Keine Ergebnisse",
    // pois: "POIs",
    pois: "Orte & Routen",
    streets: "Straßen",
    other: "Andere"
  },
  general: {
    monday: "Montag",
    tuesday: "Dienstag",
    wednesday: "Mittwoch",
    thursday: "Donnerstag",
    friday: "Freitag",
    saturday: "Samstag",
    sunday: "Sonntag",
    copy: "In die Zwischenablage kopieren"
  },
  printOverlay: {
    titlePlaceholder: "Titel (optional)",
    notesPlaceholder: "Notiz (optional)",
    print: "Drucken",
    close: "Schließen",
    pleaseWait: "Bitte warten Sie, während Ihr Ausdruck erstellt wird",
    pleaseWaitSubscript: "Dies kann mehrere Sekunden dauern."
  },
  gdpr: {
    title: "DSGVO Benachrichtigung",
    message:
      "Diese Seite verwendet anonymisierte Statistiken zur Verbesserung der Benutzererfahrung. " +
      "Mit 'Ok' bestätigen Sie, dass diese Auswertung durchgeführt werden darf.",
    ok: "Ok",
    no: "Nein danke"
  },
  wfs: {
    intro_description: "Bitte wählen Sie eine Element auf der Karte, um dessen Details anzuzeigen.",
    no_elem_found: "Es wurde kein Element an dieser Stelle gefunden.",
    unknown_error: "Ein unbekannter Fehler ist aufgetreten: "
  },
  routing: {
    title: "Routenplanung",
    instructionsTitle: "Anweisungen",
    showMore: "Mehr anzeigen",
    showLess: "Weniger anzeigen",
    startPlaceholder: "Start finden / auf die Karte klicken",
    endPlaceholder: "Ziel finden / auf die Karte klicken",
    useMyLocation: "Meinen Standort verwenden",
    needBothPoints: "Bitte Start und Ziel auswählen, um Anweisungen zu sehen.",
    loading: "Route wird geladen...",
    startNavigation: "Navigation starten",
    stopNavigation: "Navigation beenden",
    enableVoice: "Sprachführung aktivieren",
    disableVoice: "Sprachführung deaktivieren",


  },
  instructions: {
    // Kreisverkehr
    kreisverkehr: {icon: "sync", text: "Kreisverkehr"},
    "im kreisverkehr": {icon: "sync", text: "Kreisverkehr"},
    "am kreisverkehr": {icon: "sync", text: "Kreisverkehr"},

    // leicht rechts / links (înainte de cele generale)
    "leicht rechts abbiegen": {icon: "turn_slight_right", text: "Leicht rechts"},
    "leicht rechts halten": {icon: "turn_slight_right", text: "Leicht rechts"},
    "halten sie sich leicht rechts": {icon: "turn_slight_right", text: "Leicht rechts"},

    "leicht links abbiegen": {icon: "turn_slight_left", text: "Leicht links"},
    "leicht links halten": {icon: "turn_slight_left", text: "Leicht links"},
    "halten sie sich leicht links": {icon: "turn_slight_left", text: "Leicht links"},

    // rechts / links abbiegen
    "rechts abbiegen": {icon: "turn_right", text: "Rechts abbiegen"},
    "biegen sie rechts ab": {icon: "turn_right", text: "Rechts abbiegen"},
    rechts: {icon: "turn_right", text: "Rechts abbiegen"},

    "links abbiegen": {icon: "turn_left", text: "Links abbiegen"},
    "biegen sie links ab": {icon: "turn_left", text: "Links abbiegen"},
    links: {icon: "turn_left", text: "Links abbiegen"},

    // rechts / links halten
    "rechts halten": {icon: "fork_right", text: "Rechts halten"},
    "halten sie sich rechts": {icon: "fork_right", text: "Rechts halten"},

    "links halten": {icon: "fork_left", text: "Links halten"},
    "halten sie sich links": {icon: "fork_left", text: "Links halten"},

    // geradeaus / weiter
    geradeaus: {icon: "straight", text: "Geradeaus"},
    "weiter geradeaus": {icon: "straight", text: "Geradeaus"},
    "fahren sie geradeaus": {icon: "straight", text: "Geradeaus"},

    // auf der Spur bleiben
    "auf der linken spur bleiben": {icon: "fork_left", text: "Auf der linken Spur bleiben"},
    "bleiben sie auf der linken spur": {icon: "fork_left", text: "Auf der linken Spur bleiben"},
    "linke spur halten": {icon: "fork_left", text: "Auf der linken Spur bleiben"},

    "auf der rechten spur bleiben": {icon: "fork_right", text: "Auf der rechten Spur bleiben"},
    "bleiben sie auf der rechten spur": {icon: "fork_right", text: "Auf der rechten Spur bleiben"},
    "rechte spur halten": {icon: "fork_right", text: "Auf der rechten Spur bleiben"},

    "dem straßenverlauf folgen": {icon: "straight", text: "Straßenverlauf folgen"},
    "dem straßenverlauf von leobersdorfer bahnstraße folgen": {
      icon: "straight",
      text: "Straßenverlauf von Leobersdorfer Bahnstraße folgen"
    },
    "dem straßenverlauf von": {
      icon: "straight",
      text: "Dem Straßenverlauf folgen"
    },

    wenden: {icon: "u_turn_left", text: "Wenden"},
    "bitte wenden": {icon: "u_turn_left", text: "Wenden"},

    waypoint: {icon: "place", text: "Wegpunkt"},
    wegpunkt: {icon: "place", text: "Wegpunkt"}
  },
  rotateOverlay: {
    message: "Bitte drehen Sie Ihr Telefon ins Hochformat, um die Karte anzusehen."
  },
  events: {
    title: "Veranstaltungskalender",
    allEvents: "Alle",
    // allEventsSub: "Veranstaltungen",
    loading: "Veranstaltungen werden geladen...",
    noEvents: "Für den ausgewählten Monat sind keine Veranstaltungen vorhanden.",
    seeMore: "Details anzeigen",
    information: "Informationen zur Veranstaltung",
    website: "Webseite",
    location: "Standort"
  }
};
